/**
 * @generated SignedSource<<99243770d7843a9bcd6325c5cf3c6efa>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceDetailQuery$variables = {
  includeSpaceTypeSettings: boolean;
  spaceKey?: string | null | undefined;
};
export type useSpaceDetailQuery$data = {
  readonly space: {
    readonly alias: string | null | undefined;
    readonly dataClassificationTags: ReadonlyArray<string | null | undefined>;
    readonly homepage: {
      readonly id: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
    readonly spaceTypeSettings?: {
      readonly enabledContentTypes: {
        readonly isDatabasesEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isSlidesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type useSpaceDetailQuery = {
  response: useSpaceDetailQuery$data;
  variables: useSpaceDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeSpaceTypeSettings"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "dataClassificationTags"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "title"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "condition": "includeSpaceTypeSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
              {
                "concreteType": "EnabledContentTypes",
                "kind": "LinkedField",
                "name": "enabledContentTypes",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isLivePagesEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isWhiteboardsEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isDatabasesEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isSlidesEnabled"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpaceDetailQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpaceDetailQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
    "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
    "metadata": {},
    "name": "useSpaceDetailQuery",
    "operationKind": "query",
    "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
  }
};
})();

(node as any).hash = "591d4790bc30ed0352bb44ad552d45cb";

export default node;
